import { fileUploadAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const fileUploadSlotRecipe = defineSlotRecipe({
  className: 'file-upload',
  slots: fileUploadAnatomy.keys(),
  base: {
    root: {
      gap: '8',
      display: 'flex',
      flexDirection: 'column',
    },
    dropzone: {
      flex: 1,
      padding: '8',
      display: 'flex',
      cursor: 'pointer',
      borderRadius: '8',
      color: 'text/link',
      alignItems: 'stretch',
      borderColor: 'border/selected',
      backgroundColor: 'background/secondary',
      _icon: {
        color: 'icon/interactive',
      },
      _hover: {
        backgroundColor: 'background/selected',
        _active: {
          color: 'text/primary',
          borderColor: 'icon/primary',
          backgroundColor: 'background/selected-hover',
          _icon: {
            color: 'icon/primary',
          },
        },
      },
      _invalid: {
        color: 'input/text/error',
        borderColor: 'border/error',
        _icon: {
          color: 'icon/negative',
        },
      },
      _disabled: {
        cursor: 'not-allowed',
        color: 'text/on-disabled',
        borderColor: 'border/strong',
        backgroundColor: 'background/disabled',
        _icon: {
          color: 'icon/on-disabled',
        },
      },
    },
    dropzoneContent: {
      flex: 1,
      gap: '4',
      padding: '24',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: '1',
      borderStyle: 'dashed',
      borderRadius: '4',
    },
  },

  variants: {
    variant: {
      image: {
        root: {
          height: rem(256),
        },
      },
    },
  },

  defaultVariants: {},
});

export default fileUploadSlotRecipe;
